import axios, { CancelTokenSource } from 'axios';
import { WeekUnitCostDto } from 'ts-types/api.types';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/week-unit-cost`;

export const getAllWeeks = (source: CancelTokenSource): Promise<Array<WeekUnitCostDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
};

export const searchWeekPrice = (query: String, source: CancelTokenSource): Promise<Array<WeekUnitCostDto>> => {
  return axios
      .get(`${apiUri}`, {params: {query}, cancelToken: source.token})
      .then(response => response.data);
};

export const findWeekPriceByYearWeekKey = (yearWeekKey: string, source: CancelTokenSource): Promise<WeekUnitCostDto> => {
  return axios
      .get(`${apiUri}`, {params: {yearWeekKey}, cancelToken: source.token})
      .then(response => response.data)
}

export const addWeekPrice = (
    weekPriceDto: Partial<WeekUnitCostDto>, source: CancelTokenSource): Promise<WeekUnitCostDto> => {
  return axios
      .post(apiUri, weekPriceDto, {cancelToken: source.token})
      .then(response => response.data)
};

export const editWeekPrice = (
    yearWeekKey: string, weekPriceDto: Partial<WeekUnitCostDto>, source: CancelTokenSource): Promise<WeekUnitCostDto> => {
  return axios
      .put(`${apiUri}`, weekPriceDto, {params: {yearWeekKey}, cancelToken: source.token})
      .then(response => response.data);
};
